<style lang="less" rel="stylesheet/less" scoped>
    .wrapper{
        background:#ECEFF1;
        padding:18px 0;
        box-sizing:border-box;
        padding-bottom:50px;
    }
    ._inner{
        margin:0 18px;
    }
    .icon{
        text-align:center;
        img{
            width:70px;
        }
    }
    .title{
        font-size:21px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        text-align:center;
        margin:10px 0;
    }
    .box{
        background:rgba(255,255,255,1);
        border-radius:5px;
        box-shadow:0px 2px 10px 2px rgba(51,51,51,0.1);
        margin-bottom:20px;
        padding:10px 18px;
        overflow:hidden;

        h2{
            font-size:18px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            margin-bottom:20px;
            line-height:2em;
        }
        h3{
            font-size:16px;
            font-weight:bold;
            line-height:2em;
            color:rgba(51,51,51,1);
        }
        .value-status{
            color:#5BBD00;
            font-weight:bold;
            &.alert{
                color:#FE0000;
            }
        }
        .inner-box{
            margin-bottom:20px;

            ul{
                list-style: inside;
                line-height:2em;
            }
        }
    }

</style>
<template>
    <div class="wrapper" :style="{minHeight:minHeight+'px'}">
        <div class="_inner" v-if="data">
            <div class="icon">
                <img src="../images/bmi.png" alt="">
            </div>
            <div class="title">
                BMI检测结果
            </div>
            <div class="box">
                <h2>
                    {{data.title}}
                </h2>
                <div class="inner-box" v-for="item in data.info">
                    <h3>{{item.label}}</h3>
                    <ul>
                        <li>
                            目标值 ---- {{item.target || item.taget}}
                        </li>
                        <li>
                            当前值 ---- <span :class="`value-status ${item.is_normal===1 ? '' : 'alert'}`">{{item.user_data}} ({{item.is_normal===1 ? '正常' : '异常'}})</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="box">
                <h2>健康点评</h2>
                <div class="inner-box">
                    <h3>筛查建议：</h3>
                    <p>
                        {{data.comment.advice}}
                    </p>
                </div>
                <div class="inner-box">
                    <h3>控制目标：</h3>
                    <p>
                        {{data.comment.goal}}
                    </p>
                </div>
            </div>
        </div>
        <BottomBar :index="2"></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">
    import Store from '../lib/store';
    import api from '../lib/api';
    import BottomBar from '../components/BottomBar';

    export default {
        data() {
            return {
                data:null
            }
        },
        computed: {
            minHeight(){
                return Store.state.minHeight;
            }
        },
        methods: {
            async init(){
                let id = this.$route.query.id;
                let res = await api.getSurveyResultDetail(id);
                console.log(JSON.parse(res.result));

                this.data = JSON.parse(res.result);
            }
        },
        components: {
            BottomBar,
        },
        mounted() {
            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// survey-result-detail.vue?454c1a09